export default __webpack_public_path__ + "static/media/login.8e6dd84f.jpg";